import React from "react"
import { Toggle } from "material-ui"
import strings from "../../localization/strings"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import autobind from "class-autobind"
import cloneDeep from "lodash/cloneDeep"
import * as api from "../../api"
import * as accountActions from "../../actions/AccountActions"
import { IAccountDocument, IAccrualAdjustment, IAccrualSettings } from "../../models"
import Adjustments from "./Adjustments"


interface IProps {
	AccrualSettings: IAccrualSettings
}
interface IState {
    requiredAdjustmentNote: boolean
	requiredAdjustmentReason: boolean
	adjustments: Array<IAccrualAdjustment>
}

export default class AccrualAdjustmentRules extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			requiredAdjustmentNote: props.AccrualSettings.RequireAdjustmentNote,
			requiredAdjustmentReason: props.AccrualSettings.RequireAdjustmentReason,
			adjustments: props.AccrualSettings.Adjustments
		}
		autobind(this)
    }

	updateAccrualSettings() {
		const AccrualSettings: IAccrualSettings = cloneDeep(this.props.AccrualSettings)
		AccrualSettings.RequireAdjustmentNote = this.state.requiredAdjustmentNote
		AccrualSettings.RequireAdjustmentReason = this.state.requiredAdjustmentReason
		AppStateStore.setProgressSnackbarContent("loading")
		api.updateAccrualSettings(AccountStore.getCurrentAccount().Id, AccrualSettings).then(res => {
			const Account = res.data as IAccountDocument
			this.setState({ adjustments: Account.AccountSettings.AccrualSettings.Adjustments }, () => {
				AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
				accountActions.getAccount(AuthenticationStore.getCookieAccountId())
			})
		})
	}

	addorUpdateAccrualAdjustment(adjustment: IAccrualAdjustment, update: boolean) {
		AppStateStore.setProgressSnackbarContent("loading")
		api.addOrUpdateAccrualAdjustmentReason(AccountStore.getCurrentAccount().Id, adjustment).then(res => {
			const AccrualSettings = res.data as IAccrualSettings
			this.setState({ adjustments: AccrualSettings.Adjustments }, () => {
				if (update) AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
				else AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
				accountActions.getAccount(AuthenticationStore.getCookieAccountId())
			})
		})
	}

	deleteAccrualAdjustment(adjustmentIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		api.deleteAccrualAdjustmentReason(AccountStore.getCurrentAccount().Id, adjustmentIds).then(res => {
			const AccrualSettings = res.data as IAccrualSettings
			this.setState({ adjustments: AccrualSettings.Adjustments }, () => {
				AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
				accountActions.getAccount(AuthenticationStore.getCookieAccountId())
			})
		})
	}

	render() {
		return (
			<div>
                <Toggle
					data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Toggle-RequireAdjustmentNote"}
                    toggled={this.state.requiredAdjustmentNote}
                    onToggle={(event, value) => this.setState({ requiredAdjustmentNote: value }, () => this.updateAccrualSettings())}
                    labelPosition="left"
                    label={strings.Require_Adjustment_Note}
                    style={{ maxWidth: 450, marginBottom: 15 }}
                />
                <Toggle
					data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Toggle-RequireAdjustmentReason"}
                    toggled={this.state.requiredAdjustmentReason}
                    onToggle={(event, value) => this.setState({ requiredAdjustmentReason: value }, () => this.updateAccrualSettings())}
                    labelPosition="left"
                    label={strings.Require_Adjustment_Reason}
                    style={{ maxWidth: 450 }}
                />
				<Adjustments 
					readonly={false}
					adjustments={this.state.adjustments}
					addOrUpdateAdjustment={this.addorUpdateAccrualAdjustment}
					deleteAdjustment={this.deleteAccrualAdjustment}
				/>
            </div>
		)
	}
}